import {AbstractEvent} from "@/modules/base/events";
import {Sponsor} from "@/modules/sponsoring/entity";

export class AfterSponsoringOffersCreationEvent extends AbstractEvent {
  constructor(
    public offers: Sponsor[],
  ) {
    super();
  }
}